module.exports = {
	"No notifications found.": "Keine Benachrichtigungen gefunden.",
	"Notifications": "Benachrichtigungen",
	"See all notifications": "Alle Benachrichtigungen anzeigen",
	"Mark all as read": "Alles als gelesen markieren"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/de.json
// module id = 899
// module chunks = 37